export function signIn (loginMethod, redirectTo) {
    // theme 为 coocaa-pay-login 时，loginMethod 只能传一个登录方式，直接进行登录
    // theme为 coocaa-added-service 时，loginMethod 可以传多个登录方式让用户选择
    const loginUrl =
    process.env.VUE_APP_TITLE === 'production'
      ? window.location.origin
      : 'https://beta-tvshop.coocaa.com'
  const theme = loginMethod ? 'coocaa-pay-login' : 'coocaa-added-service'
  const method = loginMethod || 'weixin,qq,phoneDynameic'
  let redirect = redirectTo || encodeURIComponent(window.location.href)
    // let loginParmas = {
    //   theme: theme,
    //   loginMethod: method,
    //   redirectUri: redirect
    // };
    // this.$service.getLoginURL(loginParmas).then((res) => {
    //   console.log('~~~~res', res);
    //   window.location = `${res.data}`;
    // });
    window.location = `${loginUrl}/cc/login.html?theme=${theme}&loginMethod=${method}&redirect_to=${redirect}`
  }
